import { useCallback, useState } from 'react';
import type { SubmitHandler } from 'react-hook-form';
import { generatePath, useNavigate } from 'react-router-dom';
import { patchEntity } from '@mutations/patchEntity';
import { ApiPatchOperation } from '@root/@types/payloads';
import Nav from '@src/routes';

import type { CreateContractFormState } from '../types';

export const useCreateContract = (id: string) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleOpenEntity = useCallback(
    (id: string) => {
      const payload = { id };
      const newPath = Nav.SubmissionForm;
      const nextRoute = generatePath(newPath, payload);

      return navigate(nextRoute);
    },
    [navigate],
  );

  const handleUpdateContract: SubmitHandler<CreateContractFormState> = useCallback(
    async (data) => {
      try {
        setIsLoading(true);
        const { branding_id, copy_from_submission, copy_from_template } = data;

        await patchEntity({
          operation: ApiPatchOperation.PreDraftToDraft,
          branding_id,
          copy_from_submission,
          copy_from_template,
        });

        return handleOpenEntity(id);
      } catch (_error) {
        // Swallow the error for now
      } finally {
        setIsLoading(false);
      }
    },
    [handleOpenEntity, id],
  );

  return {
    isLoading,
    onSubmit: handleUpdateContract,
  };
};
